import {Flex, Box, Image} from 'rebass';

export const CardIcons = () => (
    <Flex
        justifyContent='space-between'
        width="225px"
        mb={6}
    >
    {['visa', 'master', 'amex'].map((cardType) => (
        <Flex
            key={cardType}
            alignItems='center'
            justifyContent='center'
            backgroundColor='white'
            css={`
                border: 3px solid lightGrey;
                border-radius: 3px;
                width: 60px;
                height: 35px;
            `}>
            <Image src={`/static/icons/payment/${cardType}.png`} />
        </Flex>
    ))}
    </Flex>
)